import React from "react"
import {DEFAULT_TENANT} from "../AppWrapper"

const FALLBACK_LOGO = "/logo--teckpro.svg"

const DEFAULT_WIDTH = "125px"
const DEFAULT_HEIGHT = "51px"

export const Logo = ({tid = DEFAULT_TENANT, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT}) => {
    return (
        <img
            src={`/logo--${tid}.svg`}
            alt="Logo"
            style={{width, height, objectFit: "contain"}}
            onError={(error) => {
                if (error.currentTarget.src.endsWith(FALLBACK_LOGO)) return
                error.currentTarget.src = FALLBACK_LOGO
            }}
        />
    )
}
